import { DependencyList, EffectCallback, useEffect } from "react";

/**
 * Like `useEffect` but compares `deps` by deep value instead of reference.
 *
 * Implementation: stringify the deps so React's shallow-equal dep check
 * becomes a deep-value comparison. Works for any JSON-serialisable values
 * (objects, arrays, primitives). Functions/symbols are not supported.
 */
export const useDeepCompareEffect = (effect: EffectCallback, deps: DependencyList) => {
    const key = JSON.stringify(deps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(effect, [key]);
};
